<template>
  <div>

      <h5>支払い管理</h5>
      <hr>

      <div class="py-3 contents">
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th style="min-width: 150px;">申し込み日</th>
              <th style="min-width: 150px;">状態（報告書、手数料支払い）</th>
              <th style="min-width: 150px;">写真</th>
              <th style="min-width: 150px;">商品のタイトル</th>
              <th style="min-width: 150px;">販売手数料（サイト側へのお支払い額）</th>
              <th style="min-width: 120px;">メッセージ（事務局側）</th>
              <th style="min-width: 140px;">メモ</th>
            </tr>
            <tr v-for="(order, index) in allGetOrders">
              <td>
                {{ date_only_format(order['created_at']) }}
              </td>
              <td>
                {{ get_hash_value(payment_status, order['payment_status']) }}
                <button v-if="String(order['payment_status']) == '0'" class="btn btn-info" @click="updateStatus(order['orders_id'], 1)">振込済みに変更</button>
              </td>
              <td style="max-width: 150px;" @click="jumpProductDetail(order['products_id'])">
                <img class="" :src="order['image1']" style="width: 100%;height: auto;">
              </td>
              <td @click="jumpProductDetail(order['products_id'])">
                {{ order['title'] }}
              </td>
              <td>
                {{ number_format(order['price']) }} 円
              </td>
              <td>
                <button class="btn btn-info" @click="jumpMessageDetail(order['messages_id'], order['users_id'])">返信</button>
              </td>
              <td>
                <button class="btn btn-info" @click="jumpMemo(order)">確認・編集</button>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div id="overlay" class="memo" v-show="displayMemoModal">
        <b-container>
          <div class="memo_modal card text-left m-auto" style="overflow: hidden;">
            <div class="card-header text-left" style="background-color: #fff;">
              <span>メモの確認・編集</span>
            </div>
            <div class="text-center mx-3 mt-3">
              <textarea placeholder="" v-model="memo" class="w-100" rows="6"></textarea>
            </div>
            <b-row class="mb-3">
              <b-col class="text-right px-4">
                <button id="memo_modal_close" type="submit" class="my-2 mx-md-3 btn btn-primary mr-sm-3 mt-sm-3 w100 p-2 px-sm-3" @click="update_memo">更新する</button>
                <button id="memo_modal_close" type="submit" class="my-2 mx-md-3 btn btn-primary mr-sm-3 mt-sm-3 w100 p-2 px-sm-3" @click="displayMemoModal=false">閉じる</button>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>

  </div>
</template>

<script>
export default {
  props: { 
    user: Object
  },
  data() {
		const status = [
			{"no":"0","name":"申し込み"},
			{"no":"2","name":"完了"},
			{"no":"9","name":"キャンセル"},
    ];
		const payment_status = [
			{"no":"0","name":"未払い"},
			{"no":"1","name":"振込済み"},
			{"no":"2","name":"振込確認中"},
			{"no":"3","name":"保留"},
			{"no":"4","name":"完了（支払い済み）"},
			{"no":"9","name":"キャンセル"},
    ];
		const payment_method_arr = [
			{"no":"1","name":"クレジットカード"},
			{"no":"2","name":"銀行振込"},
			{"no":"3","name":"その他"},
    ];
    return {
      status,
      payment_status,
      payment_method_arr,

      displayMemoModal: false,
      memo: "",
      orders_id: null,

      orders: [],
    }
  },
	methods: {
    jumpMemo(order) {
      this.orders_id = order['orders_id'];
      this.memo = order['memo'];
      this.displayMemoModal = true;
	  },
    jumpProductDetail: function(id){
        this.$router.push({path: '/product/'+String(id)});
	  },
	  jumpMessageDetail: function(id, users_id){
        this.$router.push({path: '/message/1/9/'+String(id)});
	  },
    updateStatus: function(orders_id, status){
      if(confirm("振込済みに変更してもよろしいですか?")) {
        this.exec_update_status(orders_id, status);
      }
      return false;
    },
    async exec_update_status(orders_id, status) {
      let form = {};
      form['orders_id'] = orders_id;
      form['payment_status'] = status;
      this.$store.dispatch('order/put_order', {
        order: form,
      }).then(res => {
        console.log(res);
        alert('更新が完了しました。');
        for (let i = 0; i < this.orders.length; i++) {
          if ( String(this.orders[i]['orders_id']) == String(orders_id) ) {
            this.orders[i]['payment_status'] = status;
          }
        }
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
    async update_memo() {
      let form = {};
      form['orders_id'] = this.orders_id;
      form['memo'] = this.memo;
      this.$store.dispatch('order/put_order', {
        order: form,
      }).then(res => {
        console.log(res);
        alert('更新が完了しました。');
        this.displayMemoModal = false;
        for (let i = 0; i < this.orders.length; i++) {
          if ( String(this.orders[i]['orders_id']) == String(this.orders_id) ) {
            this.orders[i]['memo'] = this.memo;
          }
        }
        this.orders_id = null;
        this.memo = "";
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
	  async get_order() {
		  this.$store.dispatch('order/get_payment', {}).then(res => {
		    console.log(res);
		    let ret = res.data.orders;
		    this.orders = ret['orders'];
		    console.log(this.orders);
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
  },
	created() {
		this.get_order();
	},
	computed: {
		allGetOrders: function() {
			return this.orders;
		},
	},
}
</script>

<style>
/* modal */
#overlay {
  z-index: 4;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

#overlay.memo,
#overlay.detail {
  z-index: 2000;
}

.memo_modal,
.detail_modal {
  margin-top: 6%!important;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  max-height: 30rem!important;
  background-color: #FFFFFF;
  box-shadow: 1px 1px 12px 1px rgba(164, 164, 164, 0.25);
  border-radius: 16px;
  width: 88%;
}

</style>



// WEBPACK FOOTER //
// src/components/mypage/seller/payment.vue